import { TextField, TextFieldProps, createStyles, makeStyles } from '@material-ui/core';
import { ReactElement } from 'react';
import cn from 'classnames';
import styles from './styles';

type Props = TextFieldProps & {
  handleChange(e: string): void;
  handleSubmit?: () => void;
};

const AuthInput = ({ handleChange, handleSubmit, label, value, type, error }: Props): ReactElement => {
  const { textField, errorText } = makeStyles((theme) => createStyles(styles(theme)))();
  return (
    <TextField
      className={cn(textField, error && errorText)}
      label={label}
      type={type}
      value={value}
      variant="outlined"
      onChange={(e) => handleChange(e.target.value)}
      error={error}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && handleSubmit) {
          handleSubmit();
        }
      }}
    />
  );
};

export default AuthInput;
